import { PlusButton } from "@components/buttons/plus";
import { PageRoutes } from "@constants";
import { useNotification } from "@hooks/useNotification";
import { useUserPermissions } from "@hooks/userUserPermission";
import { AnalysisConfigs } from "@pages/platform-analysis-v2/configs";
import { getPracticeOverviewNavigateRoute } from "@pages/platform-analysis-v2/utils";
import { RootState } from "@redux/store";
import { useSelector } from "react-redux";
import { generatePath, useNavigate } from "react-router";
import { AnalysisUpgradeToModifyNotification } from "../../notifications/modify-platform-analysis";

export const AddNewAnalysisButton = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const { notify, closeNotify } = useNotification();

  const { isAdviserTrialGroup, isAdviserGroup } = useUserPermissions();

  const handleOnClick = () => {
    if (isAdviserTrialGroup) {
      notify(
        <AnalysisUpgradeToModifyNotification
          actionType="create"
          onNavigate={() => {
            navigate(
              getPracticeOverviewNavigateRoute(
                user?.userMetadata?.adviser_firm_id,
              ),
            );
            closeNotify("create");
          }}
        />,
        {
          ...AnalysisConfigs.DefaultSnackbarOptions,
          key: "create",
        },
      );

      return;
    }

    navigate(
      generatePath(PageRoutes.platformAnalysisDetail, {
        analysisId: "new",
      }),
    );
  };

  return (
    <PlusButton variant="contained" size="extraMedium" onClick={handleOnClick}>
      {isAdviserGroup ? "New Suitability Review" : "New analysis"}
    </PlusButton>
  );
};
